import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./sell.module.scss";
const SellButton = ({ onClick }) => {
    return (_jsx("button", Object.assign({ className: `${styles.buttonContainer} ${styles.rippleEffect} rippleEffect`, onClick: onClick }, { children: "Sell" })));
};
export default SellButton;
